import utilities from '@/services/utilities/utilities';

export default {
  // player range
  selectGeneralHand: function (state, payload) {
    state.players.find(payload.playerIndex).selectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex);
  },
  deselectGeneralHand: function (state, payload) {
    state.players.find(payload.playerIndex).deselectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex);
  },
  manuallySelectGeneralHand: function (state, payload) {
    state.players.find(payload.playerIndex).manuallySelectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyDeselectGeneralHand: function (state, payload) {
    state.players.find(payload.playerIndex).manuallyDeselectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  selectGeneralHands: function (state, payload) {
    state.players.find(payload.playerIndex).selectGeneralHands(payload.generalHandStrings, state.presetCommunityCards, payload.playerStateIndex);
  },
  deselectGeneralHands: function (state, payload) {
    state.players.find(payload.playerIndex).deselectGeneralHands(payload.generalHandStrings, state.presetCommunityCards, payload.playerStateIndex);
  },
  deselectAllGeneralHands: function (state, payload) {
    state.players.find(payload.playerIndex).deselectAllGeneralHands(state.presetCommunityCards, payload.playerStateIndex);
  },
  selectSpecificHand: function (state, payload) {
    state.players.find(payload.playerIndex).selectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  deselectSpecificHand: function (state, payload) {
    state.players.find(payload.playerIndex).deselectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallySelectSpecificHand: function (state, payload) {
    state.players.find(payload.playerIndex).manuallySelectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyDeselectSpecificHand: function (state, payload) {
    state.players.find(payload.playerIndex).manuallyDeselectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyDeselectAllGeneralHands: function (state, payload) {
    state.players.find(payload.playerIndex).manuallyDeselectAllGeneralHands(state.presetCommunityCards, payload.playerStateIndex);
  },
  selectSpecificHands: function (state, payload) {
    state.players.find(payload.playerIndex).selectSpecificHands(payload.specificHandStrings, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  setSpecificHandAsManuallySet: function (state, payload) {
    state.players.find(payload.playerIndex).setSpecificHandAsManuallySet(payload.specificHandString, payload.playerStateIndex);
  },
  setSpecificHandAsNotManuallySet: function (state, payload) {
    state.players.find(payload.playerIndex).setSpecificHandAsNotManuallySet(payload.specificHandString, payload.playerStateIndex);
  },
  applyExactWeightToGeneralHand: function (state, payload) {
    state.players.find(payload.playerIndex).applyExactWeightToGeneralHand(payload.generalHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex);
  },
  applyExactWeightToGeneralHands: function (state, payload) {
    let player = state.players.find(payload.playerIndex);

    payload.generalHandsFromModal.forEachGeneralHandInRange(function (generalHandFromModalInRange) {
      player.applyExactWeightToGeneralHand(generalHandFromModalInRange.string, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex);
    });
  },
  setWeightOfSpecificHand: function (state, payload) {
    state.players.find(payload.playerIndex).setWeightOfSpecificHand(payload.specificHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyApplyExactWeightToGeneralHand: function (state, payload) {
    state.players.find(payload.playerIndex).manuallyApplyExactWeightToGeneralHand(payload.generalHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallySetWeightOfSpecificHand: function (state, payload) {
    state.players.find(payload.playerIndex).manuallySetWeightOfSpecificHand(payload.specificHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  clearManuallyAddedHands: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.clearManuallyAddedHands();
  },
  clearManuallyRemovedHands: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.clearManuallyRemovedHands();
  },
  setRangesAccordingToFilters: function (state, playerIndex, shortDeck) {
    state.players.find(playerIndex).setRangesAccordingToFilters(state.presetCommunityCards, shortDeck);
  },

  // player other
  setWeightToApplyToAddedHands: function (state, payload) {
    state.players.find(payload.playerIndex).weightToApplyToAddedHands = payload.weightToApplyToAddedHands;
  },
  addComboToCombosToAdd: function (state, payload) {
    state.players.find(payload.playerIndex).combosToAdd.pushIfNotIncluded(payload.combo);
  },
  removeComboFromCombosToAdd: function (state, payload) {
    state.players.find(payload.playerIndex).combosToAdd.removeIfIncluded(payload.combo);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.highlightMatchingGeneralHands(payload.matchingSpecificHands);
  },
  removeFiveCardHandHighlights: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.removeFiveCardHandHighlights();
  },

  // controls
  setPresetHoleCard: function (state, payload) {
    state.presetHoleCards[payload.position] = payload.card;
    state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(payload.card, payload.shortDeck);
  },
  removePresetHoleCard: function (state, position, shortDeck) {
    let holeCardToRemove = state.presetHoleCards[position];

    state.presetHoleCards[position] = null;

    if (holeCardToRemove) {
      state.players.selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(holeCardToRemove, state.presetCommunityCards, state.presetHoleCards, shortDeck);
      state.players.setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(holeCardToRemove, state.presetCommunityCards, state.presetHoleCards, shortDeck);
    }
  },
  setIndividualPresetCommunityCard: function (state, payload) {
    state.presetCommunityCards[payload.position] = payload.card;
    state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(payload.card, payload.shortDeck);
  },
  setBoard: function (state, boardCards, shortDeck) {
    if (boardCards.length === 3) {
      state.presetCommunityCards.flop1 = boardCards[0];
      state.presetCommunityCards.flop2 = boardCards[1];
      state.presetCommunityCards.flop3 = boardCards[2];
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[0], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[1], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[2], state.presetCommunityCards, shortDeck);
    } else if (boardCards.length === 4) {
      state.presetCommunityCards.flop1 = boardCards[0];
      state.presetCommunityCards.flop2 = boardCards[1];
      state.presetCommunityCards.flop3 = boardCards[2];
      state.presetCommunityCards.turn = boardCards[3];
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[0], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[1], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[2], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[3], state.presetCommunityCards, shortDeck);
    } else if (boardCards.length === 5) {
      state.presetCommunityCards.flop1 = boardCards[0];
      state.presetCommunityCards.flop2 = boardCards[1];
      state.presetCommunityCards.flop3 = boardCards[2];
      state.presetCommunityCards.turn = boardCards[3];
      state.presetCommunityCards.river = boardCards[4];
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[0], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[1], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[2], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[3], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[4], state.presetCommunityCards, shortDeck);
    }
  },
  removePresetCommunityCard: function (state, position, shortDeck) {
    let presetCommunityCardToRemove = state.presetCommunityCards[position];
    let presetHoleCards = state.presetHoleCards || { holeCardOne: '', holeCardTwo: '' };

    state.presetCommunityCards[position] = null;

    if (presetCommunityCardToRemove) {
      state.players.selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(presetCommunityCardToRemove, state.presetCommunityCards, presetHoleCards, shortDeck);
      state.players.setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(presetCommunityCardToRemove, state.presetCommunityCards, presetHoleCards, shortDeck);
    }
  },
  addPlayer: function (state, payload) {
    payload = payload || {};
    state.players.add(state.presetCommunityCards);
    state.presetCommunityCards.array.forEach(function (presetCommunityCard) {
      state.players.last.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(presetCommunityCard, payload.shortDeck);
    });

    if (payload.opponentTightness) {
      state.players.last.setFiveCardHandValuesToDefaults(state.presetCommunityCards, payload.opponentTightness, payload.settings);
      state.presetHoleCards.array.forEach(function (presetHoleCard) {
        state.players.last.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(presetHoleCard, payload.shortDeck);
      });
    }
  },
  removePlayer: function (state, playerIndex) {
    state.players.remove(playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function (state, payload) {
    payload.fiveCardHand.checked = payload.newCheckedValue;
  },
  applyExactWeightToFiveCardHand: function (state, payload) {
    payload.fiveCardHand.applyExactWeightToFiveCardHand(payload.newWeight);
  },
  uncheckAllFiveCardHandsForGivenState: function (state, payload) {
    let player = state.players.find(payload.playerIndex);

    player.states[payload.playerStateIndex].fiveCardHands.uncheckAllVisibleFiveCardHands();
  },
  checkAllFiveCardHandsForGivenState: function (state, payload) {
    let player = state.players.find(payload.playerIndex);

    player.states[payload.playerStateIndex].fiveCardHands.checkAllVisibleFiveCardHands();
  },
  setChecksToDefaultsForGivenState: function (state, payload) {
    let player = state.players.find(payload.playerIndex);
    let fiveCardHandsThatAreCheckedByDefault = player.states[payload.playerStateIndex].getFiveCardHandsThatAreCheckedByDefault(state.presetCommunityCards, payload.opponentTightness, payload.settings);

    player.states[payload.playerStateIndex].fiveCardHands.setChecksToDefaults(fiveCardHandsThatAreCheckedByDefault, player.states[payload.playerStateIndex].name);
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function (state, payload) {
    let player = state.players.find(payload.playerIndex);

    player.states[payload.playerStateIndex].fiveCardHands.setChecksAccordingToUserDefinedFilters(payload.filterName, payload.userDefinedFilters);
  },
  setFiveCardHandValuesToDefaults: function (state, payload) {
    state.players.setFiveCardHandValuesToDefaults(state.presetCommunityCards, payload.opponentTightness, payload.settings);
  },
  updateWeightOfFiveCardHand: function (state, payload) {
    payload.fiveCardHand.weight = payload.newWeight;
  },
  clearManuallySetHandsThatPassThroughFilter: function (state, payload) {
    let player = state.players.find(payload.playerIndex);
    let fiveCardHand = player.states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId);
    let presetCommunityCardsArray = state.presetCommunityCards.getArrayForStateViaIndex(payload.playerStateIndex);

    player.states[payload.playerStateIndex].generalHands.clearManuallySetHandsThatPassThroughFilter(
      fiveCardHand,
      presetCommunityCardsArray,
      payload.shortDeck,
    );
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function (state, fiveCardHandParent) {
    fiveCardHandParent.collapsed = !fiveCardHandParent.collapsed;
  },
  setProbabilitiesOfFiveCardHands: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.setProbabilities(payload.handAndDrawInfo, payload.numberOfSimulations);
  },
  setHandAndDrawInfo: function (state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].handAndDrawInfo = _.cloneDeep(payload.handAndDrawInfoFromSimulationResults);
  },
  setPercentagesOfSpecificHandsThatAreSelected: function (state, payload) {
    let playerState = state.players.find(payload.playerIndex).states[payload.playerStateIndex];

    playerState.fiveCardHands.setPercentagesOfSpecificHandsThatAreSelected(playerState.generalHands);
  },

  // simulations
  setHasSimulationBeenRun: function (state, value) {
    state.hasSimulationBeenRun = value;
  },
  setLastSimulationInfo: function (state, playerStateIndex) {
    state.players.setLastSimulationInfo(state.presetCommunityCards, state.presetHoleCards, playerStateIndex);
  },

  // cumulative hit percentages
  getPercentageOfTimeEveryoneMissesTheBoard: function (state, street) {
    let playerStateIndex = utilities.general.getPlayerStateIndexFromStreet(street);
    let missPercentages = [];

    state.players.forEach(function (player) {
      missPercentages.push(100 - player.states[playerStateIndex].hitPercentage);
    });

    return missPercentages.reduce(function (accumulator, missPercentage) {
      return accumulator * (missPercentage / 100);
    }, 1) * 100;
  },
  getPercentageOfTimeExactlyOnePlayerHitsTheBoard: function (state, street) {
    let playerStateIndex = utilities.general.getPlayerStateIndexFromStreet(street);
    let hitPercentages = [];
    let result = 0;
    let resultOfMultiplyingInverseOfOthers;

    state.players.forEach(function (player) {
      hitPercentages.push(player.states[playerStateIndex].hitPercentage);
    });
    hitPercentages.forEach(function (hitPercentageOuter, i) {
      resultOfMultiplyingInverseOfOthers = 1;
      hitPercentages.forEach(function (hitPercentageInner, j) {
        if (i === j) return;

        resultOfMultiplyingInverseOfOthers *= (1 - (hitPercentageInner / 100));
      });
      result += (hitPercentageOuter / 100) * resultOfMultiplyingInverseOfOthers;
    });

    return result * 100;
  },
  getPercentageOfTimeTwoOrMorePlayersHitTheBoard: function (state, street) {
    let percentageOfTimeEveryoneMissesTheBoard = this.getPercentageOfTimeEveryoneMissesTheBoard(state, street);
    let percentageOfTimeExactlyOnePlayerHitsTheBoard = this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street);

    return 100 - percentageOfTimeEveryoneMissesTheBoard - percentageOfTimeExactlyOnePlayerHitsTheBoard;
  },
  getCumulativeHitPercentages: function (state) {
    return {
      flop: {
        percentageOfTimeEveryoneMissesTheBoard: this.getPercentageOfTimeEveryoneMissesTheBoard(state, 'flop'),
        percentageOfTimeExactlyOnePlayerHitsTheBoard: this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, 'flop'),
        percentageOfTimeTwoOrMorePlayersHitTheBoard: this.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, 'flop'),
      },
      turn: {
        percentageOfTimeEveryoneMissesTheBoard: this.getPercentageOfTimeEveryoneMissesTheBoard(state, 'turn'),
        percentageOfTimeExactlyOnePlayerHitsTheBoard: this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, 'turn'),
        percentageOfTimeTwoOrMorePlayersHitTheBoard: this.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, 'turn'),
      },
      river: {
        percentageOfTimeEveryoneMissesTheBoard: this.getPercentageOfTimeEveryoneMissesTheBoard(state, 'river'),
        percentageOfTimeExactlyOnePlayerHitsTheBoard: this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, 'river'),
        percentageOfTimeTwoOrMorePlayersHitTheBoard: this.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, 'river'),
      },
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/service.js